import printJS from 'print-js';
import { formatDate } from '../Utils/Utils';
import api from './AxiosInstance';
import { api_URL } from './Constantes';

export class InterroComptaService {

  lettrageFournActu = async (selecteAdherent, selectedYear,) => {
    try {
      const response = await api.post(`InterroCompta/LettrageCompteFourn/${selecteAdherent}/${selectedYear}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  lettrageFournAll = async (selectedYear,) => {
    try {
      const response = await api.post(`InterroCompta/LettrageCompteFourn/${selectedYear}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAnomaliesLettrage = async (selectedYear) => {
    try {
      const response = await api.get(`InterroCompta/getAnomaliesLettrage/${selectedYear}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getLettrage = async (newLettrage) => {
    try {
      const response = await api.put(`/InterroCompta/LettrageCompte`, newLettrage, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getadherent = async (codesoc) => {
    try {
      const response = await api.get(`/InterroCompta/Participant/list/?codesoc=${codesoc}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllSocietes = async () => {
    try {
      const response = await api.get(`/Adherent/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllFournSoinCompt = async () => {
    try {
      const response = await api.get(`/InterroCompta/Specialite/list?perim=IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllFournDivCompt = async () => {
    try {
      const response = await api.get(`/PlanCompta/FournDiv/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getadherentFourn = async (compte) => {
    try {
      const response = await api.get(`/InterroCompta/Fournisseur/list?compte=${compte}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllCompteAdht = async () => {
    try {
      const response = await api.get(`/InterroCompta/Adherents/list?perim=IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllChargeTech = async () => {
    try {
      const response = await api.get(`/InterroCompta/Charges/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllProdTech = async () => {
    try {
      const response = await api.get(`/InterroCompta/Produits/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllBanques = async () => {
    try {
      const response = await api.get(`/InterroCompta/Banques/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllAutres = async () => {
    try {
      const response = await api.get(`/PlanCompta/listAll`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllListFournisDiversCompt = async (compte, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/FournDiv/${compte}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllListComptAdht = async (compte, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Adherent/${compte}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllListFournisDivCompt = async (compte, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Fournisseur/${compte}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllListChargeTech = async (comptegen, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Charges/${comptegen}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllListProdTech = async (comptegen, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Produits/${comptegen}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllListBanquesTech = async (comptegen, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Banques/${comptegen}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllListAutres = async (comptegen, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Autres/${comptegen}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  getAllListParticipant = async (comptetiers, dateDeb, dateFin) => {
    try {
      const response = await api.get(`/InterroCompta/Participant/${comptetiers}/listCompta?dateDeb=${formatDate(dateDeb)}&dateFin=${formatDate(dateFin)}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  //CE QUI CONCERNE LE COMPOSANT RAPPROCHEMENT BANQUES
  getListTable = async (rapproche, year, month, compte) => {
    try {
      // Assurez-vous que les valeurs sont correctement concaténées : année, mois, compte
      const url = `/Rapprochement/list?etat=${rapproche}&code=${compte}${month}${year}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };
  getRapprochement = async (year, month, compte) => {
    try {
      // Assurez-vous que les valeurs sont correctement concaténées : année, mois, compte
      const response = await api.get(`/Compta/Rapprochement/${compte}?annee=${year}&mois=${month}`);

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };
  addRapprochement = async (newAdd) => {
    try {
      // Assurez-vous que les valeurs sont correctement concaténées : année, mois, compte
      const url = `/Rapprochement/add`;
      const response = await api.post(url, newAdd);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };

  deleteRapprochement = async (payload) => {
    try {
      const response = await api.post(`/Rapprochement/delete`, payload);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };
  updateRapprochement = async (payload) => {
    try {
      const response = await api.put(`/Rapprochement/doRapp/oui`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updateAnnuleRapprochement = async (payload) => {
    try {
      const response = await api.put(`/Rapprochement/doRapp/non`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteRetenue = async (selectedYear, selectedMonth, selectJournal) => {
    try {
      const response = await api.delete(`/Retenues/Appel/Delete/${selectJournal}-${selectedYear}-${selectedMonth}`,);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  printBanqueComptService = (compte, selectedYear, dateDeb, dateFin) => {
    const userId = localStorage.getItem('login');
    const username = localStorage.getItem('username');
    const url = `${api_URL}Print/ExtraitDeCompte/Banque/${selectedYear}/${compte}?dateDeb=${dateDeb}&dateFin=${dateFin}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'user_id': userId,
        'username': username,
      },
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };
}